import HttpClient from '../HttpService';

const MAX_CONCURRENT_UPLOADS = 2;
const VIDEO_LIST_CACHE_MS = 5000;
let activeUploads = 0;
const uploadQueue = [];
const recordVideoLists = new Map();

function initUpload(data) {
    return HttpClient.post('/videos/record-tests/init-upload', data);
}

function completeUpload(uuid, data) {
    return HttpClient.post(`/videos/record-tests/${uuid}/complete-upload`, data);
}

function listByRecord(recordUuid, { force = false } = {}) {
    const cached = recordVideoLists.get(recordUuid);
    const now = Date.now();

    // Todos os cards da aba usam a mesma lista. Sem isso, uma aba com muitos
    // testes dispara dezenas de requests iguais e de consultas ao MediaConvert.
    if (cached?.pending) return cached.pending;
    if (!force && cached?.response && (now - cached.fetchedAt) < VIDEO_LIST_CACHE_MS) return Promise.resolve(cached.response);

    const pending = HttpClient.get(`/videos/record-tests/record/${recordUuid}`)
        .then(response => {
            recordVideoLists.set(recordUuid, { response, fetchedAt: Date.now(), pending: null });
            return response;
        })
        .catch(error => {
            recordVideoLists.delete(recordUuid);
            throw error;
        });

    recordVideoLists.set(recordUuid, { ...cached, pending });
    return pending;
}

function invalidateListByRecord(recordUuid) {
    recordVideoLists.delete(recordUuid);
}

function getPlaybackUrl(uuid) {
    return HttpClient.get(`/videos/record-tests/${uuid}/playback-url`);
}

function retry(uuid) {
    return HttpClient.post(`/videos/record-tests/${uuid}/retry`);
}

function destroy(uuid) {
    return HttpClient.delete(`/videos/record-tests/${uuid}`);
}

function queueUpload(upload) {
    return new Promise((resolve, reject) => {
        uploadQueue.push({ upload, resolve, reject });
        runQueuedUploads();
    });
}

function runQueuedUploads() {
    while (activeUploads < MAX_CONCURRENT_UPLOADS && uploadQueue.length) {
        const item = uploadQueue.shift();
        activeUploads += 1;
        item.upload()
            .then(item.resolve, item.reject)
            .finally(() => {
                activeUploads -= 1;
                runQueuedUploads();
            });
    }
}

export default { initUpload, completeUpload, listByRecord, invalidateListByRecord, getPlaybackUrl, retry, destroy, queueUpload };
